import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { usersApi } from '../../utils'
import { throwApiError } from "../lms-shared/store/error-handling-actions";
import { initLmsUser } from '../../store/auth-actions';
import Default from '../../assests/header/icon-user.png'
import classes from './ChangeUserProfilePopup.module.css';
import { onKeyDown } from "../../service";
import BackdropPopup from "../lms-shared/UI/Popups/BackdropPopup/BackdropPopup";


const ChangeUserProfilePopup = ({ closePopup }) => {
    const texts = useSelector(state => state.translate.texts);
    const user = useSelector(state => state.auth.user);
    const dispatch = useDispatch();
    const [fileToUpdate, setFileToUpdate] = useState()
    const [file, setFile] = useState()

    useEffect(() => {
        setFile(user.profileImage ? `${user.profileImage}` : Default)
    }, [])

    const handleChange = (e) => {
        setFile(URL.createObjectURL(e.target.files[0]))
        setFileToUpdate(e.target.files[0])
    }

    const changeProfile = () => {
        const opts = {
            profileImage: fileToUpdate
        }
        usersApi.usersUpdatePost(opts, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.usersUpdateError, error: error, statusCode: response?.statusCode, message: "usersUpdatePost " + error.message, level: 1, component: "ChangeUserProfilePopup", line: 33 }))
            } else {
                dispatch(initLmsUser())
                closePopup()
            }
        })
    }

    return (
        <BackdropPopup myHeight='380px'>
            <div className={classes.Popup}>
                <div className={classes.Top}>
                    <div className={classes.Top}>{texts.changeUserProfile}</div>
                    <div className={classes.Circle} onClick={closePopup} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, closePopup)}>
                        <div className={classes.XLine}></div>
                        <div className={`${classes.XLine} ${classes.Rotate}`}></div>
                    </div>
                </div>
                <div className={classes.Content}>
                    {/* <div className={classes.Img}></div>
                    <div className={classes.Zoom}></div> */}

                    <div>
                        <div style={{backgroundImage: `url(${file})`}} className={classes.DemoImg} />
                    </div>
                    <div className={classes.UploadBtn}>{texts.uploadImg}
                        <input type="file" className={classes.UploadInput} onChange={handleChange} id="FileInput" />
                    </div>
                </div>
                <div className={classes.Btn} onClick={changeProfile}>{texts.changeUserProfileBtn}</div>
            </div>
        </BackdropPopup>
    )
}

export default ChangeUserProfilePopup;